import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';

export const Stepper = ({ steps, sx, ...props }) => (
  <Box sx={{ position: 'relative', ...sx }} {...props}>
    <Flex flexDirection="column">
      {steps.map((step, index) => {
        const label = typeof step === 'string' ? step : step.label;
        const key = typeof step === 'string' ? index : step.id ?? index;

        return (
          <Flex key={key} alignItems="baseline" sx={{ gap: '8px' }}>
            <Flex sx={{ position: 'relative', flexDirection: 'column', alignItems: 'center' }}>
              <Flex
                alignItems="center"
                justifyContent="center"
                sx={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '32px',
                  backgroundColor: 'purple.300',
                  flexShrink: 0,
                }}
              >
                <Text
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: 1.4,
                    color: 'neutral.0',
                    textAlign: 'center',
                  }}
                >
                  {index + 1}
                </Text>
              </Flex>
              {index < steps.length - 1 && (
                <Box
                  sx={{
                    width: '2px',
                    height: '24px',
                    backgroundColor: 'purple.300',
                  }}
                />
              )}
            </Flex>
            {typeof label === 'string' && (
              <Text
                sx={{
                  fontSize: '14px',
                  fontWeight: 500,
                  lineHeight: 1.4,
                  color: 'text.dark',
                }}
              >
                {label}
              </Text>
            )}
            {typeof label !== 'string' && <Box sx={{ flex: 1 }}>{label}</Box>}
          </Flex>
        );
      })}
    </Flex>
  </Box>
);

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.node.isRequired,
      }),
    ]),
  ).isRequired,
  sx: PropTypes.object,
};

Stepper.defaultProps = {
  sx: {},
};

export default Stepper;
